// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RJwIGX {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
  border-radius: var(--card-border-radius);
}

.SdJsH5 {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-start;
  gap: var(--spacing-2);
  margin: 0;
}

.cMfvB1 {
  width: 1.34375rem;
  height: 1.34375rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.Ttc1PU {
  transform: scale(1.34375);
  transform-origin: center;
}

.P_OuXw {
  margin: 0;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.2em;
  box-sizing: border-box;
  font-family: var(--font-family-clario), var(--font-family-base);
  font-size: 20px;
  font-weight: var(--font-weight-regular);
  line-height: 1;
  letter-spacing: 0;
  color: #1f1f1f;
}

.EB6b34,
.ryvH2X {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  color: inherit;
}

.vZWnUH {
  display: flex;
  flex-direction: column;
  gap: 0;
  align-self: stretch;
  width: 100%;
  min-width: 0;
}

.eI6mIc {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  border-bottom: 1px solid var(--stroke-neutral-silver);
  padding-top: var(--spacing-1-5);
  padding-bottom: var(--spacing-1-5);
}

.eI6mIc:first-child {
  padding-top: 0;
}

.eI6mIc:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.XzGtSn {
  border-radius: 0 !important;
  background-color: transparent !important;
  padding: 0 !important;
  cursor: default;
  border: none !important;
  box-shadow: none !important;
}

.vZWnUH [class*='inner'] {
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-2);
  padding: 0;
}

.vZWnUH [class*='inner'] > [class*='title'] {
  flex: 1;
  min-width: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
}

.J33nYQ {
  display: block;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.COrrDZ {
  transform: rotate(180deg);
}

.vZWnUH [class*='contentExpanded'] {
  margin: 0;
  padding-top: var(--spacing-1-5);
  padding-bottom: 0;
}

.IioDNJ,
.BS1pvG {
  display: block;
  white-space: pre-line;
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
}

.YlLC83 {
  color: var(--link-default, #1573d3);
  text-decoration: underline;
}

.YlLC83:hover {
  color: var(--link-hover, #125eb3);
}

.vASnZx {
  align-self: flex-start;
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  padding: 0 var(--spacing-2);
  margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/InsideSalesBenefitsLanding/components/InsideSalesFaqSection/InsideSalesFaqSection.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,sBAAsB;EACtB,+DAA+D;EAC/D,eAAe;EACf,uCAAuC;EACvC,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,8BAA8B;EAC9B,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;EACvC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;AACf","sourcesContent":[".faqSection {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-4);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n  border-radius: var(--card-border-radius);\n}\n\n.faqTitleRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: flex-start;\n  gap: var(--spacing-2);\n  margin: 0;\n}\n\n.faqTitleIconWrap {\n  width: 1.34375rem;\n  height: 1.34375rem;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.faqTitleIconInner {\n  transform: scale(1.34375);\n  transform-origin: center;\n}\n\n.faqTitle {\n  margin: 0;\n  display: inline-flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.2em;\n  box-sizing: border-box;\n  font-family: var(--font-family-clario), var(--font-family-base);\n  font-size: 20px;\n  font-weight: var(--font-weight-regular);\n  line-height: 1;\n  letter-spacing: 0;\n  color: #1f1f1f;\n}\n\n.faqTitlePart1,\n.faqTitlePart2 {\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  letter-spacing: inherit;\n  color: inherit;\n}\n\n.faqAccordionList {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  align-self: stretch;\n  width: 100%;\n  min-width: 0;\n}\n\n.faqAccordionRow {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  border-bottom: 1px solid var(--stroke-neutral-silver);\n  padding-top: var(--spacing-1-5);\n  padding-bottom: var(--spacing-1-5);\n}\n\n.faqAccordionRow:first-child {\n  padding-top: 0;\n}\n\n.faqAccordionRow:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.faqAccordionItem {\n  border-radius: 0 !important;\n  background-color: transparent !important;\n  padding: 0 !important;\n  cursor: default;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.faqAccordionList :global([class*='inner']) {\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: 0;\n}\n\n.faqAccordionList :global([class*='inner']) > :global([class*='title']) {\n  flex: 1;\n  min-width: 0;\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n}\n\n.faqAccordionChevron {\n  display: block;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.faqAccordionChevronOpen {\n  transform: rotate(180deg);\n}\n\n.faqAccordionList :global([class*='contentExpanded']) {\n  margin: 0;\n  padding-top: var(--spacing-1-5);\n  padding-bottom: 0;\n}\n\n.faqAnswerRich,\n.faqAnswerPlain {\n  display: block;\n  white-space: pre-line;\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n}\n\n.faqInlineLink {\n  color: var(--link-default, #1573d3);\n  text-decoration: underline;\n}\n\n.faqInlineLink:hover {\n  color: var(--link-hover, #125eb3);\n}\n\n.moreButton {\n  align-self: flex-start;\n  height: 40px;\n  min-height: 40px;\n  max-height: 40px;\n  box-sizing: border-box;\n  padding: 0 var(--spacing-2);\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faqSection": `RJwIGX`,
	"faqTitleRow": `SdJsH5`,
	"faqTitleIconWrap": `cMfvB1`,
	"faqTitleIconInner": `Ttc1PU`,
	"faqTitle": `P_OuXw`,
	"faqTitlePart1": `EB6b34`,
	"faqTitlePart2": `ryvH2X`,
	"faqAccordionList": `vZWnUH`,
	"faqAccordionRow": `eI6mIc`,
	"faqAccordionItem": `XzGtSn`,
	"faqAccordionChevron": `J33nYQ`,
	"faqAccordionChevronOpen": `COrrDZ`,
	"faqAnswerRich": `IioDNJ`,
	"faqAnswerPlain": `BS1pvG`,
	"faqInlineLink": `YlLC83`,
	"moreButton": `vASnZx`
};
module.exports = ___CSS_LOADER_EXPORT___;
